export default "__VITE_ASSET__9962ec1f__"